import clsx from 'clsx';
import { ElementType, memo } from 'react';
import { Button, ButtonProps } from 'src/modules/common/components/Button/Button.tsx';

type Props<T extends React.ElementType> = ButtonProps<T> & {
    header?: boolean;
    selected?: boolean;
    danger?: boolean;
    size?: 'md' | 'lg';
}

function OverflowMenuItemWithoutMemo<T extends ElementType = 'button'>({
    ...props
}: Props<T>) {
    const { header, size, selected, kind = 'ghost' } = props;

    return (
        <Button
            type="button"
            kind={kind}
            className={clsx({
                'vss-overflow-menu-item': true,
                'vss-overflow-menu-item--md': size === 'md',
                'vss-overflow-menu-item--header': header,
                'vss-overflow-menu-item--selected': selected,
                'vss-overflow-menu-item--danger': kind === 'danger',
            })}
            {...props}
        />
    );
}

export const OverflowMenuItem = memo(OverflowMenuItemWithoutMemo) as typeof OverflowMenuItemWithoutMemo;
